// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the route (pathname) changes
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return <>{children}</>;
};

export const ScrollToTopOfComponent = (ref, options = {}) => {
  if (!ref.current) return;

  const { mobileAppBarHeight = 100, desktopAppBarHeight = 120, behavior = "smooth" } = options;

  const isMobile = window.innerWidth < 768;
  const appBarHeight = isMobile ? mobileAppBarHeight : desktopAppBarHeight;

  const elementTop = ref.current.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementTop - appBarHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: behavior,
  });
};

export default ScrollToTop;
